import {Preloader} from './Preloader';
import {Popup} from "./Popup";
import {Faq} from "./Faq";
import {MotionOnScroll} from "./MotionOnScroll";
import {Increment} from "./Increment";
import {Tabs} from "./Tabs"
import {LayoutSwitch} from "./LayoutSwitch";
import {Toggle} from "./Toggle";
import {ImageTabs} from "./ImageTabs";
import {FixedHeader} from "./FixedHeader";
import {Anchor} from "./Anchor";
import {CookiesWarning} from "./CookiesWarning";
import {CallbackButton} from "./CallbackButton";
import {VideoPopup} from "./VideoPopup";
import {UrlHashNavigation} from "./UrlHashNavigation";
import {ScrollBox} from "./Scrollbox";
import {FormValidator} from "./FormValidator";
import {Dropdown} from "./Dropdown";
import {Splide} from '@splidejs/splide';
import {Timer} from "./Timer";
import {LazyBackground} from "./LazyBackground";
import {Map} from "./Map";
import {URLHash} from '@splidejs/splide-extension-url-hash';

require('smoothscroll-for-websites');
const
    LazyLoad = require('lazyload'),
    GLightbox = require('glightbox');

document.addEventListener( 'DOMContentLoaded',  () => {
    const theme = window.theme;

    // Initializing the preloader
    const preloader = new Preloader ({
        element: `.preloader`,
        timeout: 400
    }).init();

    // Lazy loading for images
    if (theme.settings.lazy) {
        const images = document.querySelectorAll(`.lazy-image`);
        new LazyLoad(images);
        new LazyBackground(`lazy-background-image`);
    }

    // Creating pop-up windows
    const sidePanel = new Popup ({
        window: `.side-panel__layout`,
        overlay: `#side-overlay`
    });
    sidePanel.addTriggers(`.menu-button, .side-panel__close, #side-overlay`);

    const feedbackPanel = new Popup ({
        window: `.feedback-popup__layout`,
        overlay: `#feedback-overlay`
    });
    feedbackPanel.addTriggers(`.feedback-btn, .feedback-popup__close, #feedback-overlay`);
    if (theme.settings.feedback) feedbackPanel.toggle();

    const callbackButton = new CallbackButton (`.fixedbtn`, feedbackPanel, `cookies`);

    const videoPopup = new VideoPopup({
        window: `.video-button-one__popup`
    });
    videoPopup.addTriggers(`.video-button-one`);

    //Map
    const maps = document.querySelectorAll(`.contacts`);
    maps.forEach(element => {
        new Map({
            containers: element.querySelectorAll(`.contacts__map`)
        });
    });

    // Faq list
    const faq = document.querySelectorAll(`.faq__question`);
    faq.forEach(element => {
        const faq = new Faq({
            question: element as HTMLElement,
            answer: element.nextElementSibling as HTMLElement
        });
    });

    // Adding motion on scroll
    const mos = [`.cards`, `.six-cards`, `.projects`, `.features`, `.advantages`, `.statistics`, `.list`];
    for (let i = 0; i < mos.length; i++) {
        const blocks = document.querySelectorAll(mos[i]);
        blocks.forEach(block => new MotionOnScroll(block as HTMLElement));
    }

    // Incrementing Numbers
    const ni = document.querySelectorAll(`.counter-one__number`);
    ni.forEach(element => new Increment({element: element as HTMLElement}));

    // Adding modals
    const modals = [`.phone-one`, `.breadcrumbs`];
    modals.forEach(selector => {
        const modals = document.querySelectorAll(selector);
        modals.forEach(modal => {
            new Dropdown({
                dropdown: modal.querySelector(`${selector}__dropdown`),
                trigger: modal.querySelector(`${selector}__button`),
                container: document.body
            })
        });
    });

    // Adding toggles
    const nav = document.querySelectorAll(`.sidebar-navigation__item`);
    nav.forEach(it => {
        new Toggle({
            triggers: it.querySelectorAll(`.sidebar-navigation__toggle`),
            target: it.querySelector(`.sidebar-navigation__sublist`)
        });
    });

    // Initializing tabs
    const tabs = document.querySelectorAll(`.tabs`);
    tabs.forEach(element => {
        new Tabs({
            tabs: element.querySelectorAll(`.tabs__item`),
            content: element.querySelectorAll(`.tabs__content-item`)
        })
    });

    const description = document.querySelectorAll(`.description`);
    description.forEach(element => {
        new Tabs({
            tabs: element.querySelectorAll(`.description__tab`),
            content: element.querySelectorAll(`.description__content-item`)
        })
    });

    const services = new LayoutSwitch({
        tabs: document.querySelectorAll(`.services__item`),
        content: document.querySelectorAll(`.services__bg`)
    });

    // Cookies warning
    new CookiesWarning({
        popup: document.querySelector(`.js-cookies`),
        trigger: document.querySelector(`.js-cookies-button`),
        cookie: `cookies`,
        animation: `fadeOut`,
        timeout: 1000
    });

    // Fixing header
    const fixed = document.querySelector(`.menu-button`) as HTMLElement;
    if (theme.settings.fixedHeader) new FixedHeader({element: fixed});

    // Anchors
    const anchors = document.querySelectorAll(`.is-anchor`);
    anchors.forEach(element => new Anchor({element: element as HTMLElement}));

    // Timer
    const timers = document.querySelectorAll(`.timer`);
    timers.forEach(element => new Timer({container: element as HTMLElement}));

    // Initializing lightboxes
    const lightbox = GLightbox({
        selector: `.g-light-box`,
        svg: {
            close: '',
            next:
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                    <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                </svg>`,
            prev:
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                    <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                </svg>`
        },
        skin: ''
    });

    // Products
    const gallerys = [`.product-two`];
    gallerys.forEach(selector => {
        const gallery = document.querySelectorAll(selector);
        gallery.forEach(element => {
            new ImageTabs({
                image: element.querySelector(`img`),
                tabs: element.querySelectorAll(`li`)
            })
        });
    });

    // Sliders
    const carousel = document.querySelectorAll(`.carousel__splide`);
    carousel.forEach(element => {
        const carousel = new Splide( element as HTMLElement, {
            type: 'loop',
            arrows: false,
            pagination: false,
            speed: 200,
            breakpoints: {
                '480': {
                    perPage: 2,
                },
                '768': {
                    perPage: 3,
                },
                '992': {
                    perPage: 4,
                },
                '1300': {
                    perPage: 5,
                },
            },
            perPage: 6,
            gap: '1rem',
            perMove: 1,
            drag: 'free',
            slideFocus: false,
            classes: {
                pagination: 'splide__pagination carousel__pagination',
                page : 'splide__pagination__page carousel__page'
            },
        }).mount();

        if (carousel.options.perPage < carousel.length) {
            carousel.options.pagination = true;
            carousel.refresh();
        }
    });

    const blog = document.querySelectorAll(`.blog__splide`);
    blog.forEach(element => {
        new Splide(element as HTMLElement, {
            type: 'loop',
            pagination: false,
            breakpoints: {
                '768': {
                    perPage: 1,
                    gap: '1rem',
                },
                '1100': {
                    perPage: 2,
                    gap: '1rem',
                },
            },
            perPage: 3,
            gap: '1rem',
            perMove: 1,
            drag: 'free',
            slideFocus: false,
            classes: {
                arrows: 'splide__arrows blog__arrows',
                arrow : 'splide__arrow blog__arrow',
                prev  : 'splide__arrow--prev blog__arrow--prev',
                next  : 'splide__arrow--next blog__arrow--next',
            },
        }).mount();
    });

    const gallery = document.querySelectorAll(`.gallery__splide`);
    gallery.forEach(element => {
        new Splide(element as HTMLElement, {
            pagination: false,
            breakpoints: {
                '768': {
                    perPage: 1,
                    perMove: 1,
                    gap: '1rem',
                },
                '1100': {
                    perPage: 2,
                    perMove: 2,
                },
            },
            perPage: 3,
            gap: '2rem',
            perMove: 3,
            slideFocus: false,
        }).mount();
    });

    const products = document.querySelectorAll(`.product-one__splide`);
    products.forEach((element) => {
        new Splide( element as HTMLElement, {
            arrows : true,
            pagination : false,
            slideFocus: false,
            classes: {
                arrows: 'splide__arrows product-one__arrows',
                arrow : 'splide__arrow product-one__arrow',
                prev  : 'splide__arrow--prev product-one__arrow--prev',
                next  : 'splide__arrow--next product-one__arrow--next',
            },
        } ).mount();
    });

    const slider = document.querySelectorAll(`.slider__splide`);
    slider.forEach(element => {
        new Splide( element as HTMLElement, {
            type  : 'fade',
            breakpoints: {
                '768': {
                    drag: true
                }
            },
            drag: false,
            arrows : false,
            pagination : false,
            slideFocus: false,
        } ).mount( {URLHash} );
    });

    // URL hash navigation
    const navigation = document.querySelectorAll(`.slider__nav-list`);
    navigation.forEach(element => {
        new UrlHashNavigation(element);
    });

    // Scrollbox
    const scrollbox = document.querySelectorAll('.scrollbox');
    for (let element of scrollbox) {
        new ScrollBox({
            viewport: element.querySelector('.scrollbox__viewport'),
            content: element.querySelector('.scrollbox__content-box')
        });
    }

    // Initializing form validator
    const validator = new FormValidator({
        form: document.getElementById(`feedback`),
        name: document.getElementById(`name`) as HTMLInputElement,
        phone: document.getElementById(`phone`) as HTMLInputElement,
        agreement: document.getElementById(`agree`) as HTMLInputElement,
        email: document.getElementById(`email`) as HTMLInputElement
    });
});